import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useStudents(studentId) {
    const { request } = useAuth(); // this wraps axios with auth headers
    const queryClient = useQueryClient();

    // Fetch courses
    const studentQuery = useQuery({
        queryKey: ['student'],
        queryFn: () => request.get('/student/getStudent').then((res) => res.data),
    });


    // Add course
    const addStudentMutation = useMutation({
        mutationFn: (data) => request.post('/student/addStudent', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['student'] });
        },
    });

    const updateStudentMutation = useMutation({
        mutationFn: (data) => request.put('/student/updateStudent', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['student'] });
        },
    });

    const deleteStudentMutation = useMutation({
        mutationFn: (id) => request.delete('/student/deleteStudent', { data: { id } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['student'] });
        },
    });

    // Fetch courses
    // const certificatesQuery = useQuery({
    //     queryKey: ['certificates', enrollment_no],
    //     queryFn: () =>
    //       request
    //         .get(`/student/getCertificate`, {
    //           params: { enrollment_no },
    //         //   responseType: 'arraybuffer' // ✅ THIS tells Axios to treat the response as binary
    //         })
    //         .then((res) => res.data),
    //          enabled: !!enrollment_no,
    //   });
    
    const fetchCertificateByStudentId = async (studentId) => {
        const res = await request.get('/student/getCertificate', {
          params: { studentId },
        });
        return res.data;
      };
      

      const fetchCertificateByEnrollment = async (enrollment_no) => {
        const res = await request.get('/student/getCertificateByEnrollment', {
          params: { enrollment_no },
        //   responseType: 'arraybuffer',
        });
        return res.data;
      };
      
        // // Fetch certificate by enrollment number
        // const certificateByEnrollmentQuery = useQuery({
        //     queryKey: ['certificateByEnrollment', studentId],
        //     queryFn: () =>
        //     request
        //         .get('/student/getCertificateByEnrollment', {
        //         params: { enrollment_no: studentId },
        //         responseType: 'arraybuffer',
        //         })
        //         .then((res) => res.data),
        //     enabled: !!studentId, // Only enable if studentId is present
        // });

    return {
        // Queries
        students: studentQuery?.data?.students || [],
        isStudentsLoading: studentQuery.isLoading,
        fetchCertificateByStudentId,
        // isLoadingCertificates: certificatesQuery.isLoading,
        certificateByEnrollment:fetchCertificateByEnrollment || null,
        // isLoadingCertificateByEnrollment: certificateByEnrollmentQuery.isLoading,

        // Mutations
        addStudent: addStudentMutation.mutateAsync,
        isAddingStudent: addStudentMutation.isPending,
        updateStudent: updateStudentMutation.mutateAsync,
        isUpdatingStudent: updateStudentMutation.isPending,
        deleteStudent: deleteStudentMutation.mutateAsync,
        isDeletingStudent: deleteStudentMutation.isPending,

    };
}
